import React, { useState, useEffect } from "react";
import {
  Form,
  DatePicker,
  Radio,
  Row,
  Col,
  Select,
  Input,
  Button,
  Table,
  message,
} from "antd";
import { getRiderList, exportRiderList } from "../../../../api/api";
import moment from "moment";
const { RangePicker } = DatePicker;
const labelStyleObj = {
  labelCol: { span: 7 },
  wrapperCol: { span: 17 },
};
const itemStyle = { width: "300px", marginRight: "15px" };

const RiderData = () => {
  const [form] = Form.useForm();
  const [tableData, setTableData] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `共 ${total} 条`,
  });

  useEffect(() => {
    getRiderListData();
  }, []);
  const [loading, setLoading] = useState(false);

  const handlerChange = (dates, dateStrings) => {
    if (dates === null) {
      form.setFieldsValue({
        rangeDate: null,
      });
    }
  };
  const radioChange = (e) => {
    const startDate = moment()
      .subtract(e.target.value - 1, "days")
      .format("YYYY-MM-DD");
    const endDate = moment().format("YYYY-MM-DD");
    form.setFieldsValue({
      rangeDate: [moment(startDate), moment(endDate)],
    });
  };
  const exportExcel = () => {
    const { rangeDate, keyword } = form.getFieldsValue();
    const params = {
      keyword: keyword ? keyword.trim() : "",
      beginTime: rangeDate ? moment(rangeDate[0]).format("YYYY-MM-DD") : "",
      endTime: rangeDate ? moment(rangeDate[1]).format("YYYY-MM-DD") : "",
    };
    try {
      exportRiderList(params);
    } catch (error) {
      message.error("接口请求失败");
    }
  };
  // 重置
  const resetForm = () => {
    form.resetFields();
  };
  const submit = () => {
    // 查询时重置到第一页
    setPagination({
      ...pagination,
      current: 1,
    });
    getRiderListData({ pageNum: 1 });
  };
  //获取骑手列表数据
  const getRiderListData = async (pageParams = {}) => {
    const { rangeDate, keyword } = form.getFieldsValue();
    setLoading(true);
    const params = {
      // 关键字去除前后空格
      keyword: keyword ? keyword.trim() : "",
      beginTime: rangeDate ? moment(rangeDate[0]).format("YYYY-MM-DD") : "",
      endTime: rangeDate ? moment(rangeDate[1]).format("YYYY-MM-DD") : "",
      pageNum: pageParams.pageNum || pagination.current,
      pageSize: pageParams.pageSize || pagination.pageSize,
    };
    try {
      const { data: res } = await getRiderList(params);
      if (!res.success) return message.error(res.retMsg);
      setTableData(res.data.list);
      setPagination({
        ...pagination,
        current: pageParams.pageNum || pagination.current,
        pageSize: pageParams.pageSize || pagination.pageSize,
        total: res.data.totalCount,
      });
    } catch (error) {
      console.log(error);
      message.error("接口请求失败");
    } finally {
      setLoading(false);
    }
  };
  // 分页变化处理
  const handleTableChange = (newPagination) => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    });
    getRiderListData({
      pageNum: newPagination.current,
      pageSize: newPagination.pageSize,
    });
  };
  // 列表字段
  const tableColumns = [
    {
      title: "跑单日期",
      dataIndex: "date",
      key: "date",
      align: "center",
      width: 180,
    },
    {
      title: "站点ID",
      dataIndex: "elePointId",
      key: "elePointId",
      align: "center",
    },
    {
      title: "站点名称",
      dataIndex: "pointName",
      key: "pointName",
      align: "center",
      width: 180,
    },
    {
      title: "骑手ID",
      dataIndex: "eleCourierId",
      key: "eleCourierId",
      align: "center",
    },
    {
      title: "骑手姓名",
      dataIndex: "staffName",
      key: "staffName",
      align: "center",
    },
    {
      title: "手机号",
      dataIndex: "staffPhone",
      key: "staffPhone",
      align: "center",
    },
    {
      title: "接单量",
      dataIndex: "acceptOrderCount",
      key: "acceptOrderCount",
      align: "center",
    },
    {
      title: "有效完成单量",
      dataIndex: "validOrderCount",
      key: "validOrderCount",
      align: "center",
    },
    {
      title: "超时单量",
      dataIndex: "timeoutOrderCount",
      key: "timeoutOrderCount",
      align: "center",
    },
    {
      title: "超时率",
      dataIndex: "timeoutOrderRate",
      key: "timeoutOrderRate",
      align: "center",
    },
    {
      title: "差评单量",
      dataIndex: "badEvaluateOrderCount",
      key: "badEvaluateOrderCount",
      align: "center",
    },
    {
      title: "好评单量",
      dataIndex: "goodOrderCount",
      key: "goodOrderCount",
      align: "center",
    },
    {
      title: "投诉率",
      dataIndex: "feedbackOrderRate",
      key: "feedbackOrderRate",
      align: "center",
    },
    {
      title: "差评率",
      dataIndex: "badEvaluateOrderRate",
      key: "badEvaluateOrderRate",
      align: "center",
    },
    {
      title: "坏单率",
      dataIndex: "badOrderRate",
      key: "badOrderRate",
      align: "center",
    },
    {
      title: "好评率",
      dataIndex: "goodOrderRate",
      key: "goodOrderRate",
      align: "center",
    },
    {
      title: "骑手在线时长",
      dataIndex: "riderOnlineTime",
      key: "riderOnlineTime",
      align: "center",
    },
    {
      title: "午高峰骑手在线时长",
      dataIndex: "riderNoonOnlineTime",
      key: "riderNoonOnlineTime",
      align: "center",
    },
    {
      title: "晚高峰骑手在线时长",
      dataIndex: "riderNightOnlineTime",
      key: "riderNightOnlineTime",
      align: "center",
    },
  ];
  return (
    <div>
      <Form
        form={form}
        labelAlign="left"
        scroll={{ x: "max-content", y: 520 }}
        {...labelStyleObj}
      >
        <Row>
          <Form.Item label="时间" name="rangeDate">
            <RangePicker
              allowClear
              format={"YYYY-MM-DD"}
              onChange={handlerChange}
            />
          </Form.Item>
          <Form.Item style={{ width: "600px", marginLeft: "15px" }}>
            <Radio.Group onChange={radioChange}>
              <Radio value={1}>今天</Radio>
              <Radio value={7}>近7天</Radio>
              <Radio value={30}>近30天</Radio>
            </Radio.Group>
          </Form.Item>
        </Row>
        <Row>
          <Form.Item style={itemStyle} name="keyword" label="关键字">
            <Input placeholder="姓名丨身份证号丨手机号 | 所在城市" />
          </Form.Item>
        </Row>
        <Row>
          <Col span={24} style={{ textAlign: "right" }}>
            <Button
              type="primary"
              onClick={submit}
              style={{ marginRight: "15px" }}
            >
              查询
            </Button>
            <Button onClick={resetForm}>重置</Button>
            <Button
              type="primary"
              style={{ marginLeft: "15px" }}
              onClick={exportExcel}
            >
              导出
            </Button>
          </Col>
        </Row>
      </Form>
      <Table
        columns={tableColumns}
        dataSource={tableData}
        pagination={pagination}
        onChange={handleTableChange}
        bordered
        size="middle"
        loading={loading}
        rowKey={(record) => record.id}
      />
    </div>
  );
};

export default RiderData;
